import BaseComponent from "./BaseComponent";

import Swiper, { Navigation } from 'swiper';

export default class VirtualExhibitionSlider extends BaseComponent {
    constructor() {
        super();


        this._virtuelExhibitionSlider = null;

        this._modules = [ Navigation ];

        this._container = '.virtual-exhibition-slider.swiper';

        this._params = null


        this._initSwiper();
    }

    _initSwiper() {
        const params = {
            modules: this._modules,
            speed: 0,
            autoHeight: true,
            allowTouchMove: false,
            navigation: {
                prevEl: '.virtual-exhibition-slider-controls-wrapper .virtual-exhibition-slider-controls.virtual-exhibition-slider-prev',
                nextEl: '.virtual-exhibition-slider-controls-wrapper .virtual-exhibition-slider-controls.virtual-exhibition-slider-next',
            },
        };

        this._virtuelExhibitionSlider = new Swiper(this._container, params);
    }
}
